import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

function SimilarFestival() {
  const { t } = useI18n();

  return (

    <>
      <>
        <Header />
        <>
          {/* Page Header Section Start */}
          <div className="page-header bg-section parallaxie">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  {/* Page Header Box Start */}
                  <div className="page-header-box">
                    <h1 className="text-anime-style-3" data-cursor="-opaque">{t('pages.similarFestivalTitle')}</h1>

                  </div>
                  {/* Page Header Box End */}
                </div>
              </div>
            </div>
          </div>
          {/* Page Header Section End */}

             {/* About Us Section Start */}
             <div className="about-us-gold" id="about-us">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                {/* About Us Images Start */}
                                <div className="about-us-images-gold">
                                    {/* About Image Counter Start */}
                                    <div className="about-image-counter-gold">
                                        {/* About Image Start */}
                                        <div className="about-img-1-gold">
                                            <figure className="image-anime ">
                                                <img src="images/Media (3).jpg" alt="" />
                                            </figure>
                                        </div>
                                        {/* About Image End */}
                                        {/* About Counter Box Start */}
                                        <div className="about-counter-box-gold">
                                            <div className="about-counter-header-gold">
                                                
                                                <p>The Rio Festival, Brazil</p>
                                            </div>
                                            <div className="about-counter-body-gold">
                                                <a href="">
                                                    <img src="images/Media (2).jpg" alt="" />
                                                </a>
                                            </div>
                                           
                                        </div>
                                        {/* About Counter Box End */}
                                    </div>
                                    {/* About Image Counter End */}
                                    {/* About Image Start */}
                                    <div className="about-img-2-gold">
                                        <figure className="image-anime">
                                            <img src="images/Media (1).jpg" alt="" />
                                        </figure>
                                    </div>
                                    {/* About Image End */}
                                </div>
                                {/* About Us Images End */}
                            </div>
                            <div className="col-lg-6">
                                {/* About Us Content Start */}
                                <div className="about-us-content-gold">
                                    {/* Section Title Start */}
                                    <div className="section-title">
                                        <h3 className="wow fadeInUp">{t('pages.similarGlobalH3')}</h3>
                                        <h2 className="text-anime-style-3" data-cursor="-opaque">{t('pages.similarGlobalH2')}</h2>
                                        <br></br>
                                        <div class="post-entry">
                                            <blockquote className="wow fadeInUp" data-wow-delay="0.4s"><p>{t('pages.similarQuote')}</p></blockquote>
                                        </div>

                                        <p className="wow fadeInUp" data-wow-delay="0.2s">{t('pages.similarP1')}</p>

                                    </div>
                                    {/* Section Title End */}
                                       <p className="wow fadeInUp" data-wow-delay="0.2s"> {t('pages.similarRioP')} </p>

                                </div>
                                {/* About Us Content End */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* About Us Section End */}
                

                   {/* Our Facts Section Start */}
                   <div className="our-facts-gold">
                            <div className="container">
                            <div className="row section-row">
                             
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                {/* Our Fact Box Start */}
                                <div className="our-fact-box-gold">
                                    {/* Fact Box 1 Start */}
                                    <div className="fact-box-1-gold">
                                    {/* Fact Item Start */}
                                    <div className="fact-item-gold">
                                        <div className="icon-box">
                                        <img src="images/icon-fact-item-1-gold.svg" alt="" />
                                        </div>
                                        <div className="fact-item-content-gold">
                                        <h2>
                                            <span className="counter">Mardi Gras </span>New Orleans
                                        </h2>
                                        <p>Mardi Gras in New Orleans is a centuries-old celebration with deep historic and cultural significance. Originating from medieval European traditions, Mardi Gras refers to "Fat Tuesday" in French. It is celebrated to mark the last day of feasting before the Christian season of Lent begins.</p>
                                        </div>
                                    </div>
                                    {/* Fact Item End */}
                                    {/* Fact Image Start */}
                                    <div className="fact-image-gold">
                                        <figure className="image-anime ">
                                        <img src="images/Media (10).jpg" alt="" />
                                        </figure>
                                    </div>
                                    {/* Fact Image End */}
                                    </div>
                                    {/* Fact Box 1 End */}
                                    {/* Fact Box 2 Start */}
                                    <div className="fact-box-2-gold">
                                    {/* Fact Image Start */}
                                    <div className="fact-image-gold">
                                        <figure className="image-anime ">
                                        <img src="images/Media (8).jpg" alt="" />
                                        </figure>
                                    </div>
                                    {/* Fact Image End */}
                                    </div>
                                    {/* Fact Box 2 End */}
                                    {/* Fact Box 3 Start */}
                                    <div className="fact-box-3-gold">
                                    {/* Fact Image Start */}
                                    <div className="fact-image-gold">
                                        <figure className="image-anime ">
                                        <img src="images/Media (4).jpg" alt="" />
                                        </figure>
                                    </div>
                                    {/* Fact Image End */}
                                    {/* Fact Image Content Start */}
                                    <div className="fact-image-content-gold">
                                        {/* Fact Item Start */}
                                        <div className="fact-item-gold fact-dark-box-gold">
                                        <div className="icon-box">
                                            <img src="images/icon-fact-item-2-gold.svg" alt="" />
                                        </div>
                                        <div className="fact-item-content-gold">
                                            <h2>
                                            <span className="counter">Carnival of Venice </span>Italy
                                            </h2>
                                            <p>The Carnival of Venice, Italy, is renowned for its elaborate masks and rich cultural traditions. Its origins trace back to the Middle Ages, with the first official mention in 1094 and becoming a public holiday in 1296. The carnival gives an opportunity to people from all classes to wear masks and enjoy freedom from social boundaries</p>
                                        </div>
                                        </div>
                                        {/* Fact Item End */}
                                        {/* Fact Image Start */}
                                        <div className="fact-image-gold">
                                        <figure className="image-anime ">
                                            <img src="images/Media (5).jpg" alt="" />
                                        </figure>
                                        </div>
                                        {/* Fact Image End */}
                                    </div>
                                    {/* Fact Image Content End */}
                                    </div>
                                    {/* Fact Box 3 End */}
                                </div>
                                {/* Our Fact Box End */}
                                </div>
                            </div>
                            </div>
                        </div>
                        {/* Our Facts Section End */}


                        {/* About Us Section Start */}
                        <div className="about-us-royal">
                            <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-6">
                                {/* About Us Images Start */}
                                <div className="about-us-images-royal">
                                    {/* About Image 1 Start */}
                                    <div className="about-img-1-royal">
                                    <figure className="image-anime ">
                                        <img src="images/th.jpg" alt="" />
                                    </figure>
                                  
                                    </div>
                                    {/* About Image 1 End */}
                                    {/* About Image 2 Start */}
                                    <div className="about-img-2-royal">
                                    <figure className="image-anime ">
                                        <img src="images/th2.jpg" alt="" />
                                    </figure>
                                    </div>
                                    {/* About Image 2 End */}
                                </div>
                                {/* About Us Images End */}
                                </div>
                                <div className="col-lg-6">
                                {/* Hero Content Box Start */}
                                <div className="about-us-content-royal">
                                    {/* Section Title Start */}
                                    <div className="section-title">
                                    
                                    <h2 className="text-anime-style-3" data-cursor="-opaque">{t('pages.similarSongkranTitle')}</h2>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s">{t('pages.similarSongkranP')}</p>
                                    </div>
                                    {/* Section Title End */}
                                    
                            
                                </div>
                                {/* Hero Content Box End */}
                                </div>
                            </div>
                            </div>
                        </div>
                        {/* About Us Section End */}






        </>

        <Footer />
      </>

    </>
  );
}

export default SimilarFestival;